<!--zx_rts_db.t_rt_cars（车辆表）-dialog-->
<template>
  <el-dialog :title="showTitle" :visible.sync="showFlag" v-if="showFlag">
    <el-form
      :inline="true"
      :model="formData"
      class="demo-ruleForm"
      label-width="100px"
      :rules="formRules"
      ref="formData"
      :size="GLOBAL.config.systemSize"
      element-loading-text="数据处理中...请稍等..."
      v-loading="loading">

      <!--区域-->
      <el-form-item label="所属乡镇：" prop="ssxzbm" style="margin-top: 20px" v-if="addCarInfo">
<!--        <cascader :set-props="setProps"-->
<!--                  :set-size="GLOBAL.config.systemSize" maxlength="64"-->
<!--                  ref="myArea">-->
<!--        </cascader>-->
        <el-select v-model="formData.ssxzbm"
                   :size="GLOBAL.config.systemSize"
                   @change="selectChange"
                   placeholder="请选择"
                   style="width: 100%;" clearable :disabled="editFlag">
          <el-option :label="item.name" :value="item.code"
                     v-for="item in xzList"
                     :key="item.code"></el-option>
        </el-select>
      </el-form-item>
      <!--车牌号码-->
      <el-form-item label="车牌号码：" prop="cph" style="margin-top: 20px" v-if="addCarInfo">
        <el-input v-model="formData.cph" placeholder="车牌号码" maxlength="64"></el-input>
      </el-form-item>
      <!--管辖区域-->
      <el-form-item  label="管辖区域：" prop="sscjbm" style="margin-top: 20px" v-if="addCarInfo">
        <cascader :set-props="setManageProps"
                  :set-size="GLOBAL.config.systemSize" maxlength="64"
                  ref="myAreaMore" :is-disabled="false">
        </cascader>
      </el-form-item>

    </el-form>
    <el-row class="margin-top-20">
      <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
      <el-button v-if="editableFlag" type="primary" @click="saveOrUpdateForm" style="margin: 0 20px;"
                 :size="GLOBAL.config.systemSize">保存
      </el-button>
    </el-row>
  </el-dialog>
</template>
<script>
  import cascader from '../../components/Cascader'

  export default {
    name: 'cars',
    props: {
      id: {
        type: String
      },
      refresh: {
        type: Function
      },
      closeSelf: {
        type: Function
      }
    },
    data () {
      return {
        xzList: JSON.parse(localStorage.getItem('xzList')),
        addCarInfo: false,
        formData: {
            ssxzbm: '', // 区域代码
            ssxzmc: '', // 区域名称
            cph: '', // 车牌号
            sscjbm: [] // 管理区域
        },
        // 校验规则
        formRules: {
            ssxzbm: [
                {required: true, message: '所属乡镇不能为空', trigger: 'blur'}
            ],
            cph: [
                {required: true, message: '车牌号不能为空', trigger: 'blur'}
            ],
            sscjbm: [
                {required: true, message: '管辖区域不能为空', trigger: 'blur'}
            ]
        },
        // 管理区域
        setManageProps: {
          multiple: true, // 多选
          checkStrictly: false, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        // 所属区域
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        // 字典数据
        dictionary: {},
        editableFlag: true,
        loading: false,
        showTitle: '新增',
        showFlag: false,
        editFlag: false
      }
    },
    components: {
      cascader
    },
    methods:
      {
        selectCode:function(){ console.log(1111111111)},
        selectChange:function(val){
          console.log(val)
          let _this = this
          setTimeout(function () {
            _this.$refs.myAreaMore.carAreaData(val)
          }, 100)
          // this.$refs.myAreaMore.carAreaData(val)
        },
        open: function (type, rowData) {
          let _this = this
          let _title = ''
          _this.editFlag = false;
          if (type === 'add') {
            _title = '驾驶员新建编辑'
          } else if (type === 'edit') {
            _title = '驾驶员编辑'
          } else if (type === 'addCarInfo') {
            _title = '抽粪车辆新建'
            _this.formData = {
                ssxzbm: '', // 区域代码
                ssxzmc: '', // 区域名称
                cph: '', // 车牌号
                sscjbm: [] // 管理区域
            }
            _this.addCarInfo = true
          } else if (type === 'editCarInfo') {
            _title = '抽粪车辆编辑'
            _this.addCarInfo = true
            _this.editFlag = true
          }
          _this.showTitle = _title
          _this.showFlag = true
          if (rowData) {
            _this.formData = rowData

            // 调用级联组建内 init 方法重组默认值
            setTimeout(function () {
                // _this.$refs.myArea.init(_this.formData.SSXZBM)
                _this.$refs.myAreaMore.init(_this.formData.sscjbm)
            }, 100)
          }
        },
        closeDialog: function () {
          this.showFlag = false
          this.$refs['formData'].resetFields();
        },
        saveOrUpdateForm: function () {
          // // 参数处理======start==========
          // let myAreaObj = this.$refs.myArea.sendToParent('obj')
          if (!this.formData.ssxzbm) {
            this.$message.warning('请选择所属乡镇～')
            return
          }
          if (!this.formData.cph) {
            this.$message.warning('请输入车牌号～')
            return
          }
          let checkedNode = this.$refs.myAreaMore.sendToParent('value')
          if (checkedNode.length == 0) {
            this.$message.warning('请勾选管辖区域～')
            return
          }
          // this.formData.ssxzbm = myAreaObj[0].code
          this.formData.sscjbm = checkedNode.join(',')
          // 参数处理======end============
          let _this = this
          this.xzList.forEach(item => {
             if (item.code === _this.formData.ssxzbm) {
                 _this.formData.ssxzmc = item.name
             }
          })
          let type = "";
          if (_this.formData.uuid) {
            type = "updateAll";
          } else {
            type = "add";
          }
          _this.loading = true
          let params = {
              type: type,
              baseService: 'TGcClServiceImpl',
              info: _this.FUNCTIONS.systemFunction.removeNullFields(_this.formData)
          }
          _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            params,
            resultData => {
              _this.loading = false
              if (resultData.code === '200') {
                if (type === 'add') {
                    _this.$message.success('保存成功～请及时绑定司机！')
                } else {
                    _this.$message.success('保存成功～！')
                }
                _this.showFlag = false
                _this.$props.refresh && this.$props.refresh('init')
              } else {
                _this.$message.warning('保存失败～'+ resultData.errorMsg)
              }
            },
            () => {
              _this.loading = false
            })
        }
      }
  }
</script>



// WEBPACK FOOTER //
// src/view/setFunction/CarEditor.vue